import { Modal } from '../../ui/Modal.tsx';

/**
 * Where the button is on iOS, because there is no dialog to open.
 *
 * Safari exposes no install API at all: the only thing a page can do is describe the Share
 * sheet and trust the person to find it. Extracted from the banner because the Profile row
 * needs the same words — two copies of a set of instructions is exactly the kind of thing
 * that gets corrected in one place and not the other.
 */
export function InstallInstructions({ onClose }: { onClose: () => void }) {
  return (
    <Modal title="Add to home screen" onClose={onClose}>
      <div className="stack">
        <ol className="install-steps">
          <li>
            Tap <strong>Share</strong> at the bottom of Safari — the square with an arrow coming
            out of it.
          </li>
          <li>
            Scroll down and choose <strong>Add to Home Screen</strong>.
          </li>
          <li>
            Tap <strong>Add</strong>.
          </li>
        </ol>

        <p className="settings-hint">
          The icon gets its own sign-in, so it will ask for your password once. After that it
          stays signed in.
        </p>
      </div>
    </Modal>
  );
}
